import { useEffect, useState } from 'react'
import { AiSummaryCard } from '@/components/ai-summary-card/AiSummaryCard'
import { getCaseSummary } from '@/content-viewer/fetch/get-case-summary'
import { isAbortError } from '@/util/errors/is-abort-error'

/** Summary state belongs to the mounted opinion viewer, never to a citation descriptor. */
export function CaseSummaryPanel({ parentId }: { parentId: string | null | undefined }) {
  const [summary, setSummary] = useState<string | null>(null)
  const [expanded, setExpanded] = useState(false)
  const [dismissed, setDismissed] = useState(false)

  useEffect(() => {
    if (!parentId) return
    const controller = new AbortController()
    void getCaseSummary(parentId, controller.signal)
      .then((longSummary) => setSummary(longSummary))
      .catch((error: unknown) => {
        if (!isAbortError(error)) setSummary(null)
      })
    return () => controller.abort()
  }, [parentId])

  if (!summary || dismissed) return null
  return (
    <AiSummaryCard
      title="Case Summary"
      summary={summary}
      expanded={expanded}
      onToggle={() => setExpanded(!expanded)}
      onDismiss={() => setDismissed(true)}
      className="mb-4"
    />
  )
}
